import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

import {fetchUserIdentityData} from '../../dataFetchers/noAuthDataFetcher'
import { Configuration } from "../../configs/Configuration";
import { parseQueryParams } from '../../helpers/URLHelper';
import {setUserHash} from '../../actions/userDataActions';
import { currentAuthToken } from '../../helpers/authHelper'
import DashboardContainer from '../../components/dashboard/DashboardContainer';
import BCLLoading from '../../components/common/Loading/BCLLoading';
import Unauthorized from '../../components/common/Error/Unauthorized/Unauthorized';
import { isAuthenticatedUsingSSO } from '../../actions/ssoActions';
import { bidgelyStorage } from '../../helpers/storageHelper';

class AuthenticationLayer extends React.Component{
    configuration = Configuration.getConfiguration();

    componentDidMount(){
        let options={
            "pilot-id" : this.configuration.pilotId,
            "client-id" : this.configuration.clientId
        }
        let userHash = null;
        if(this.props.location.search !== ""){
           let parsedString = parseQueryParams(this.props.location.search);
            if (parsedString['user-hash']) {
                userHash = parsedString['user-hash'];
                bidgelyStorage.setItem('userHash', userHash);
                // Remove SSO related keys from local storage if somebody loading user with user-hash
                // it could be a different user
                bidgelyStorage.removeItem('sso');
                bidgelyStorage.removeItem('isCobrowsing');
            }
        }
        userHash = "1576049018506v1vWeLqEHNOeAoLWZ5c5Vb9jHc0mfDwcNOEUnS1XW5aicrcFDwTEt8EA9yOObE8iToQWTbVXKNb8ARrIF6w9jMkA==";
        this.props.setUserHash(userHash);
        this.props.fetchUserIdentityData(userHash, options);
    }

    render(){
        return(
            <>
                {this.props.userHash.userHashExpired ?
                    <Unauthorized />
                :
                    ((currentAuthToken !== null) && (this.props.userIdentityDetails !== null) ? <Route component={DashboardContainer}/> : <BCLLoading />)}
            </>
        )
    }
}

const mapStateToProps = state => {
    return{
        userIdentityDetails : state.userIdentityDetails,
        userHash : state.userHash
    }
}

const mapDispatchToProps = dispatch => {
    return{
        setUserHash : (userHash) => dispatch(setUserHash(userHash)),
        fetchUserIdentityData : (userHash, options) => dispatch(fetchUserIdentityData(userHash, options)),
        isAuthenticatedUsingSSO: () => dispatch(isAuthenticatedUsingSSO())
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(AuthenticationLayer);
